/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';

class IconThree extends React.Component {
  render() {
    return (
      <svg viewBox="-44 0 511 511.999">
        <path
          fill="none"
          stroke="#827ddc"
          strokeWidth="10"
          d="M416.82 208.418H296.578c-12.976 0-23.531 10.559-23.531 23.535v72.66h-25.082v-40.597c0-12.977-10.555-23.532-23.531-23.532h-32.485a8.5 8.5 0 0 1-6.601-3.129l-16.73-20.445L302.854 11.605a7.497 7.497 0 0 0-2.171-10.382A7.505 7.505 0 0 0 290.3 3.395l-81.883 125.234-52.148-44.32 34.863-73.598a7.502 7.502 0 0 0-3.57-9.988 7.503 7.503 0 0 0-9.989 3.57l-71.586 151.129-51.875 51.875c-9.176 9.176-9.176 24.101 0 33.277l62.754 62.754c6.45 6.453 14.207 11.113 22.676 13.758a23.358 23.358 0 0 0-2.77 11.059v72.664H24.031C11.055 400.809.5 411.363.5 424.339V504.5c0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5v-80.16c0-4.707 3.828-8.535 8.531-8.535h120.242c4.141 0 7.5-3.356 7.5-7.496v-80.164c0-4.704 3.829-8.532 8.532-8.532h120.242c4.14 0 7.5-3.36 7.5-7.5v-80.16c0-4.707 3.828-8.531 8.531-8.531H416.82a7.502 7.502 0 0 0 0-15.004zM121.016 158.73l14.214-30.003 46.864 40.168-23.438 35.84zm79.129-17.445l-9.774 14.945-48.484-41.558 7.734-16.328zM156.18 304.613c-10.844 0-21.04-4.222-28.707-11.89l-62.754-62.754c-3.328-3.328-3.328-8.739 0-12.067l7.41-7.406 70.16 70.16a23.381 23.381 0 0 0 16.64 6.895h33.438a7.5 7.5 0 0 0 7.5-7.5c0-4.145-3.355-7.5-7.5-7.5H158.93a8.497 8.497 0 0 1-6.035-2.5l-70.16-70.164 28.917-28.914 62.086 75.882a23.438 23.438 0 0 0 18.211 8.63h32.485c4.703 0 8.53 3.827 8.53 8.53v8.536h-8.534a7.497 7.497 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h8.535v17.062zm0 0" 
        />
      </svg>
    );
  }
}

export default IconThree;



// WEBPACK FOOTER //
// ./src/routes/home/img/icons/IconThree.js